import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const sanitise = ({userId, courseId, ...rest}) => ({
    userId: Number(userId),
    courseId: Number(courseId),
    ...rest
});

class CourseProgressStore extends ReduceStore {
    getInitialState() {
        return [];
    }

    getProgress(courseId, userId) {
        return this.getState().filter(elem => (!!elem && elem.courseId === courseId && elem.userId === userId));
    }

    reduce(state, action) {
        let data;
        switch (action.type) {
            case ActionTypes.COURSE_PROGRESS_LIST_SUCCESS:
                data = this.prepareData(action.payload);

                return [
                    ...data,
                    ...action.data.map(sanitise)
                ];

            default:
                return state;
        }
    }

    prepareData({courseId, userId}) {
        if (!courseId && !userId) { return []; }

        return this.getState().filter(e => e.courseId !== courseId && e.userId !== userId);
    }
}

export default new CourseProgressStore(CentricDispatcher);
